import React from 'react';
import MaskedInput from 'react-maskedinput';

import TextField from './TextField';

export default function MaskedTextField(props) {
  return (
    <TextField
      inputComponent={MaskedInput}
      {...props}
    />
  );
}



/** WEBPACK FOOTER **
 ** ./client/form/MaskedTextField.js
 **/